import { useState } from 'react';
import { Logs } from './ModalTable/LogType';

export const useModalState = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [logs, setLogs] = useState<Logs>([]);
  const [fileName, setFileName] = useState('');

  const openModal = (logData: Logs, name: string) => {
    setLogs(logData);
    setFileName(name);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    // Delay clearing content to allow modal closing animation to complete
    setTimeout(() => {
      setLogs([]);
      setFileName('');
    }, 300);
  };

  return {
    closeModal,
    fileName,
    isModalOpen,
    logs,
    openModal,
  };
};
